const prefix = '/auth' as const;

export const LoginEndpoints: Record<string, string> = {
  login: `${prefix}/token`,
  refreshAccessToken: `${prefix}/token/refresh`,
  forgotPassword: `${prefix}/forgot-password`,
  resetPassword: `${prefix}/reset-password`,
  requestOtp: `${prefix}/otp/request`,
  autologinUniversalLink: '/universal-links/autologin',
};
